import React from 'react';
import { connect } from 'react-redux';
import {
  addNewStep,
  editStepTitle,
  addStepData,
  clearAddonStep,
  removeStepAddonItem,
  removeAddonStep,
  clearAllSteps,
  closeStepDataModal,
  selectCurrentStepSelection,
  addVariationItem,
  editVariationItem,
  removeVariationItem,
  orderVariationItem,
  setComboSteps,
  setProductVariationsData,
} from '../../store/actions';

const withCreateProductAddons = WrappedComponent => {
  const mapStateToProps = state => ({
    productAddons: state.productAddons,
  });

  const mapDispatchToProps = dispatch => ({
    addNewStep: () => dispatch(addNewStep()),
    editStepTitle: (step, title) => dispatch(editStepTitle(title, step)),
    addStepData: (step, data, addonType) => dispatch(addStepData(step, data, addonType)),
    clearAddonStep: step => dispatch(clearAddonStep(step)),
    removeStepAddonItem: (step, id) => dispatch(removeStepAddonItem(step, id)),
    removeAddonStep: step => dispatch(removeAddonStep(step)),
    clearAllSteps: () => dispatch(clearAllSteps()),
    closeStepDataModal: clearStep => dispatch(closeStepDataModal(clearStep)),
    selectCurrentStepSelection: (step, addonType) =>
      dispatch(selectCurrentStepSelection(step, addonType)),
    addVariationItem: (variation, order, isGlobal) =>
      dispatch(addVariationItem(variation, order, isGlobal)),
    editVariationItem: variation => dispatch(editVariationItem(variation)),
    removeVariationItem: id => dispatch(removeVariationItem(id)),
    orderVariationItem: (id, currPos, newPos) => dispatch(orderVariationItem(id, currPos, newPos)),
    setComboSteps: steps => dispatch(setComboSteps(steps)),
    setProductVariations: variations => dispatch(setProductVariationsData(variations)),
  });

  const closeModal = (clearStep, closeStepDataModal) => {
    closeStepDataModal(clearStep);
  };

  const CreateAddonsContainer = props => (
    <WrappedComponent
      {...props}
      closeStepDataModal={(clearStep = false) => closeModal(clearStep, props.closeStepDataModal)}
    />
  );

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateAddonsContainer);
};

export default withCreateProductAddons;



// WEBPACK FOOTER //
// ./src/containers/CreateProductsAddons/index.js